var map = {
	"./area.svg": 36,
	"./arrow-left.svg": 37,
	"./arrow-right.svg": 38,
	"./bed.svg": 39,
	"./close.svg": 40,
	"./down.svg": 41,
	"./down2.svg": 42,
	"./download.svg": 43,
	"./followup.svg": 44,
	"./grid.svg": 45,
	"./menu.svg": 46,
	"./plus.svg": 47,
	"./shower.svg": 48,
	"./up.svg": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;